module.exports = new __parcel__URL__("info-background.3cdd6630.png").toString();